<div class="row">
	<div class="col-12">
		<div class="content-header">Account Settings</div>
	</div>
	<div class="col-12">
		<button *ngIf="guideline_data" class="btn btn-outline-primary" (click)="openDynamicModal(guideline_data)">Bulk Guideline</button>
	  </div>
	<!-- <div>
		<p>Outsource leads close status delete </p>
		<button class="btn btn-outline-primary"(click)="deleteOutsourceLeadByCloseStatus()">Delete</button>
	</div> -->
</div>
<div class="col mt-3">
	<div *ngFor="let list of rows; let i=index">
		<div class="main_heading cursor-pointer" (click)="collapse.toggle()" [attr.aria-expanded]="empTypeView[i]"
		  aria-controls="collapseExample">
		  <h5 [ngClass]="{'bg-light-warning  ': list?.name =='HRM',
						  'bg-light-success ': list?.name =='CRM',
						  'bg-light-danger  ': list?.name =='Job',
						  'bg-light-info ': list?.name =='Training',
						  'bg-light-primary ': list?.name =='Utility',
						  'bg-light-info ': list?.name =='Tools'}">

			{{list?.name }}</h5>
		</div>
		<div  #collapse="ngbCollapse" [(ngbCollapse)]="!empTypeView[i]">
			<div class="row">
			  <div class="col-xl-3 col-lg-6 col-12" *ngIf="list?.name =='HRM' || list?.name =='CRM' || list?.name == 'Training'">
				<div class="card">
				  <div class="card-content">
					<div class="card-body">
					  <div class="media">
						<div class="media-body text-left">
						  <h5 [ngClass]="{'text-warning  ': list?.name =='HRM',
						  'text-success ': list?.name =='CRM',
						  'text-danger  ': list?.name =='Job',
						  'text-info ': list?.name =='Training',
						  'text-primary ': list?.name =='Utility',
						  'text-info ': list?.name =='Tools'}">
							{{list?.name }} Setting</h5>
							<span *ngIf="list?.name == 'HRM'"><p><strong>Employee delete ( 3 years old ) </strong></p></span>
							<button *ngIf="list?.name == 'HRM'" class="btn btn-outline-primary"(click)="confirmDeleteEmp()">Delete</button>
						  <span *ngIf="list?.name == 'CRM'"><p><strong>Outsource leads close status delete </strong></p></span>
						  
						  <button *ngIf="list?.name == 'CRM'" class="btn btn-outline-primary"(click)="deleteOutsourceLeadByCloseStatus()">Delete</button>
						  <span *ngIf="list?.name == 'Training'"><p><strong> Add checklist to the enrolled and completed students which there have no checklist. </strong></p></span>
						  
						  <button *ngIf="list?.name == 'Training'" class="btn btn-outline-primary"(click)="alertToAddBulkChecklist()">Add Checklist To Enrollments</button>
						</div>
					  </div>
					</div>
				  </div>
				</div>
			  </div>
			<div class="col-xl-3 col-lg-6 col-12" *ngIf="list?.name =='HRM' || list?.name =='CRM' || list?.name == 'Training'">
				<div class="card">
					<div class="card-content">
						<div class="card-body">
							<div class="media">
								<div class="media-body text-left">
									<h5 [ngClass]="{'text-warning  ': list?.name =='HRM',
									  'text-success ': list?.name =='CRM',
									  'text-danger  ': list?.name =='Job',
									  'text-info ': list?.name =='Training',
									  'text-primary ': list?.name =='Utility',
									  'text-info ': list?.name =='Tools'}">
										{{list?.name }} Setting
									</h5>
									<span *ngIf="list?.name == 'HRM'">
										<p><strong>Employee delete ( 3 years old ) </strong></p>
									</span>
									<button *ngIf="list?.name == 'HRM'" class="btn btn-outline-primary"
										(click)="confirmDeleteEmp()">Delete</button>
									<span *ngIf="list?.name == 'CRM'">
										<p><strong>Outsource leads close status delete </strong></p>
									</span>
			
									<button *ngIf="list?.name == 'CRM'" class="btn btn-outline-primary"
										(click)="deleteOutsourceLeadByCloseStatus()">Delete</button>
									<span *ngIf="list?.name == 'Training'">
										<p><strong> Delete the training lead Dump Data.</strong></p>
									</span>
									<button *ngIf="list?.name == 'Training'" class="btn btn-outline-primary"
										(click)="confirmDeleteDump()">Delete Dump</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			  <div class="col-xl-3 col-lg-6 col-12" *ngIf="list?.name =='CRM'">
				<div class="card">
				  <div class="card-content">
					<div class="card-body">
					  <div class="media">
						<div class="media-body text-left">
						  <h5 [ngClass]="{'text-warning  ': list?.name =='HRM',
						  'text-success ': list?.name =='CRM',
						  'text-danger  ': list?.name =='Job',
						  'text-info ': list?.name =='Training',
						  'text-primary ': list?.name =='Utility',
						  'text-info ': list?.name =='Tools'}">
							{{list?.name }} Setting</h5>
						  <span *ngIf="list?.name == 'CRM'"><p><strong>Outsource leads move open status to close status (old records). </strong></p></span>
						  
						  <button *ngIf="list?.name == 'CRM'" class="btn btn-outline-primary"(click)="currentStatusToClose('outsource-leads')">Move to Close</button>
						</div>
					  </div>
					</div>
				  </div>
				</div>
			  </div>
			  <div class="col-xl-3 col-lg-6 col-12" *ngIf="list?.name =='CRM'">
				<div class="card">
				  <div class="card-content">
					<div class="card-body">
					  <div class="media">
						<div class="media-body text-left">
						  <h5 [ngClass]="{'text-warning  ': list?.name =='HRM',
						  'text-success ': list?.name =='CRM',
						  'text-danger  ': list?.name =='Job',
						  'text-info ': list?.name =='Training',
						  'text-primary ': list?.name =='Utility',
						  'text-info ': list?.name =='Tools'}">
							{{list?.name }} Setting</h5>
						  <span *ngIf="list?.name == 'CRM'"><p><strong>Training leads move open status to close status (old records). </strong></p></span>
						  
						  <button *ngIf="list?.name == 'CRM'" class="btn btn-outline-primary"(click)="currentStatusToClose('training-leads')">Move to Close</button>
						</div>
					  </div>
					</div>
				  </div>
				</div>
			  </div>
			  <div class="col-xl-3 col-lg-6 col-12" *ngIf="list?.name =='CRM'">
				<div class="card">
				  <div class="card-content">
					<div class="card-body">
					  <div class="media">
						<div class="media-body text-left">
						  <h5 [ngClass]="{'text-warning  ': list?.name =='HRM',
						  'text-success ': list?.name =='CRM',
						  'text-danger  ': list?.name =='Job',
						  'text-info ': list?.name =='Training',
						  'text-primary ': list?.name =='Utility',
						  'text-info ': list?.name =='Tools'}">
							{{list?.name }} Setting</h5>
						  <span *ngIf="list?.name == 'CRM'"><p><strong>Outsource leads delete close status (1 year old records). </strong></p></span>
						  
						  <button *ngIf="list?.name == 'CRM'" class="btn btn-outline-primary"(click)="confirmDelete()">Delete</button>
						</div>
					  </div>
					</div>
				  </div>
				</div>
			  </div>
			  <div class="col-xl-3 col-lg-6 col-12" *ngIf="list?.name =='CRM'">
				<div class="card">
				  <div class="card-content">
					<div class="card-body">
					  <div class="media">
						<div class="media-body text-left">
						  <h5 [ngClass]="{'text-warning  ': list?.name =='HRM',
						  'text-success ': list?.name =='CRM',
						  'text-danger  ': list?.name =='Job',
						  'text-info ': list?.name =='Training',
						  'text-primary ': list?.name =='Utility',
						  'text-info ': list?.name =='Tools'}">
							{{list?.name }} Setting</h5>
						  <span *ngIf="list?.name == 'CRM'"><p><strong>Training leads delete (1 year old records). </strong></p></span>
						  
						  <button *ngIf="list?.name == 'CRM'" class="btn btn-outline-primary" (click)="confirmDeleteTraining()">Delete</button>
						</div>
					  </div>
					</div>
				  </div>
				</div>
			  </div>
			</div>
		</div>
	  </div>
</div>
